import { render, staticRenderFns } from "./ResendCodeOption.vue?vue&type=template&id=a4d3096e&scoped=true"
import script from "./ResendCodeOption.vue?vue&type=script&lang=js"
export * from "./ResendCodeOption.vue?vue&type=script&lang=js"
import style0 from "./ResendCodeOption.vue?vue&type=style&index=0&id=a4d3096e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d3096e",
  null
  
)

export default component.exports